import {
  type PopupProps,
  Leaderboard as LeaderboardPopup
} from '@CS/components/Popups';

import API from '@/services/api';
import { connect } from 'react-redux';
import { useCurrentWeek } from '@/hooks';

import type { Username } from '@/redux/user/types';
import { getUserUsername } from '@/redux/user/selectors';
import type { CampaignGame } from '@/services/api/types';
import { getCampaignGame } from '@/redux/campaign/selectors';

type LeaderboardProps = PopupProps & {
  username: Username;
  game: CampaignGame;
};

const Leaderboard = ({ username, game, ...props }: LeaderboardProps) => {
  const week = useCurrentWeek(game);

  const getWeekScores = async (week: number) => {
    const leaderboard = await API.getCampaignLeaderboard(game.id, {
      rangeNumber: week + 1
    });

    const {
      position = -1,
      participant: { score = 0 }
    } = leaderboard.my ?? {
      participant: {}
    };

    return {
      userData: { name: username ?? '', position, score },

      weekScores: leaderboard.items.map(({ user, score }) => ({
        name: user.username,
        score: score
      }))
    };
  };

  return (
    <LeaderboardPopup
      getWeekScores={getWeekScores}
      currentWeek={week}
      {...props}
    />
  );
};

const mapStateToProps = (state: never) => ({
  username: getUserUsername(state),
  game: getCampaignGame(state)
});

export default connect(mapStateToProps)(Leaderboard);
